import { IApiResponse, ISearchResponse } from '../../../common/models/common';
import request from '../../../utils/request';
import {
  ISearchConfigOnlineProductServicePlans,
  IConfigOnlineProductServicePlans,
} from './onlineProductServicePlans.model';

class ConfigOnlineProductServicePlansService {
  ENDPOINT = '/config-online-product-service-plans';

  public async searchConfigOnlineProductServicePlans(
    searchParams?: ISearchConfigOnlineProductServicePlans
  ): Promise<IApiResponse<ISearchResponse<IConfigOnlineProductServicePlans>>> {
    const url = `${this.ENDPOINT}/search`;
    return request({ url, method: 'POST', data: searchParams }).then((res) => {
      return res.data;
    });
  }

  public async getConfigOnlineProductServicePlansById(id: number): Promise<any> {
    const url = `${this.ENDPOINT}/${id}`;
    return request({ url, method: 'GET' }).then((res) => {
      return res.data;
    });
  }

  public async saveConfigOnlineProductServicePlans(
    data: IConfigOnlineProductServicePlans
  ): Promise<any> {
    const { id, ...restData } = data;
    if (id > 0) {
      const url = `${this.ENDPOINT}/${id}`;
      return request({ url, method: 'PUT', data: restData }).then((res) => {
        return res.data;
      });
    } else {
      const url = `${this.ENDPOINT}`;
      return request({ url, method: 'POST', data: restData }).then((res) => {
        return res.data;
      });
    }
  }

  public async deleteConfigOnlineProductServicePlans(id: number): Promise<any> {
    const url = `${this.ENDPOINT}/${id}`;
    return request({ url, method: 'DELETE' }).then((res) => {
      return res.data;
    });
  }

  public async exportExcelFile(
    searchParams?: ISearchConfigOnlineProductServicePlans
  ): Promise<any> {
    const url = `back-ground-processes/export-excel`;
    return request({
      url,
      method: 'POST',
      data: searchParams,
    }).then((res) => {
      return res;
    });
  }
}
export default new ConfigOnlineProductServicePlansService();
